// import { CorporationSidebarMenu } from "../sidebar/CorporationSidebarMenu";
// import Header from "../Header";
// import { CorporationName } from "../../atoms/CorporationName";
//
//
// const CorporationHeader = () => {
//   return <Header name={<CorporationName/>} sideBarMenu={<CorporationSidebarMenu/>}/>
// };
// export default CorporationHeader;

import React from "react";
import ResponsiveHeader from "./ResponsiveHeader";
import { CorporationSidebarMenu } from "../sidebar/CorporationSidebarMenu";
import { CorporationName } from "../../atoms/CorporationName";
import { LogoutModal } from "../LogoutModal";

const CorporationHeader = () => {
    return (
        <ResponsiveHeader
            name={null}
            title="BLOCKs"
            navItems={[<LogoutModal key="logout" />]}
            sidebar={<CorporationSidebarMenu />}
        />
    );
};

export default CorporationHeader;